import { ArchiveRestore, Building, ChevronDown, CircleFadingArrowUp, DatabaseBackup, Globe, Send, Settings, Terminal, Trash, HardDriveUpload, Users, EthernetPort, FileStack, BookOpenText } from "lucide-react";
import { Sidebar, SidebarContent, SidebarFooter, SidebarGroup, SidebarGroupContent, SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem, SidebarMenuSub, SidebarMenuSubItem, SidebarRail } from "./ui/sidebar";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "./ui/collapsible";

export default function DashboardSidebar() {

    const appItems = [
        // {
        //     title: 'Dashboard',
        //     url: '/',
        //     icon: <Home />
        // },
        // {
        //     title: 'Settings',
        //     url: '/settings',
        //     icon: <Settings />
        // },
        {
            title: 'Companies',
            url: '/companies',
            icon: <Building />
        },
        {
            title: 'Domains',
            url: '/domains',
            icon: <Globe />
        },
        {
            title: 'Ftp Connections',
            url: '/ftp',
            icon: <HardDriveUpload />
        },
        {
            title: 'Users',
            url: '/users',
            icon: <Users />
        },
        {
            title: 'Connection Check',
            url: '/domains/connection',
            icon: <EthernetPort />
        },
        {
            title: 'Versions',
            url: '/versions',
            icon: <FileStack  />
        },
        {
            title: 'Documentation',
            url: '/documentation/1',
            icon: <BookOpenText   />
        }
    ];

    const deploymentItems = [
        {
            title: 'Deploy',
            url: '/deployment/deploy',
            icon: <Send />
        },
        {
            title: 'Upgrade',
            url: '/deployment/upgrade',
            icon: <CircleFadingArrowUp />
        },
        {
            title: 'Backup',
            url: '/deployment/backup',
            icon: <ArchiveRestore />
        },
        {
            title: 'Recovery',
            url: '/deployment/recovery',
            icon: <DatabaseBackup />
        },
        {
            title: 'Delete',
            url: '/deployment/delete',
            icon: <Trash />
        }
    ]

    const footerItems = [
        {
            title: 'Settings',
            url: '/settings',
            icon: <Settings />
        }
    ]

    return (
        <Sidebar collapsible="icon">
            <SidebarHeader className="dark:bg-black dark:text-white">

                <SidebarMenu>
                    {/**TODO: Fix this */}
                    {/* <SidebarMenuItem>
                        <SidebarMenuButton>

                            {(() => {
                                const [user] = useCurrentUser();
                                return (
                                    <UserAvatar
                                        name={user ? `${user.U_Firstname}${user.U_Lastname ? ' ' + user.U_Lastname : ''}` : "Guest"}
                                        email={user?.U_Email || "guest@example.com"}
                                        avatarUrl={user?.U_Profile || undefined}
                                    />
                                );
                            })()}


                        </SidebarMenuButton>
                    </SidebarMenuItem> */}

                </SidebarMenu>
            </SidebarHeader>

            <SidebarContent className="dark:bg-black dark:text-white">
                <SidebarGroup>
                    <SidebarGroupContent>
                        <SidebarMenu>
                            {appItems.map((item) => (
                                <SidebarMenuItem key={item.title}>
                                    <SidebarMenuButton asChild>
                                        <a href={item.url}>
                                            {item.icon}
                                            <span>{item.title}</span>
                                        </a>
                                    </SidebarMenuButton>

                                </SidebarMenuItem>
                            ))}
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>
                <SidebarGroup>
                    <SidebarMenu>
                        <Collapsible defaultOpen className="group/collapsible">
                            <SidebarMenuItem>
                                <CollapsibleTrigger asChild>
                                    <SidebarMenuButton>
                                        <Terminal />
                                        <span>Deployment</span>

                                        <ChevronDown className="ml-auto" />
                                    </SidebarMenuButton>
                                </CollapsibleTrigger>
                                <CollapsibleContent>
                                    <SidebarMenuSub>
                                        {deploymentItems.map((item) => (
                                            <SidebarMenuSubItem key={item.title}>
                                                <SidebarMenuButton asChild>
                                                    <a href={item.url}>
                                                        {item.icon}
                                                        <span>{item.title}</span>
                                                    </a>
                                                </SidebarMenuButton>
                                            </SidebarMenuSubItem>
                                        ))}
                                    </SidebarMenuSub>
                                </CollapsibleContent>
                            </SidebarMenuItem>
                        </Collapsible>
                    </SidebarMenu>
                </SidebarGroup>
            </SidebarContent>
            <SidebarFooter className="dark:bg-black dark:text-white">
                <SidebarGroup>
                    <SidebarGroupContent>
                        <SidebarMenu>
                            {footerItems.map((item) => (
                                <SidebarMenuItem key={item.title}>
                                    <SidebarMenuButton asChild>
                                        <a href={item.url}>
                                            {item.icon}
                                            <span>{item.title}</span>
                                        </a>
                                    </SidebarMenuButton>

                                </SidebarMenuItem>
                            ))}
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>
            </SidebarFooter>
            <SidebarRail />
        </Sidebar>
    )
}